/**
 * Admin Onboarding Slides
 * 
 * Content for the admin onboarding carousel shown when a user
 * is assigned the familie_admin role.
 */

import type { OnboardingSlide } from "../types";

/**
 * Admin onboarding slides (5 slides)
 */
export const ADMIN_ONBOARDING_SLIDES: OnboardingSlide[] = [
  {
    id: "welcome",
    title: "Je bent Familie Admin!",
    description: "Gefeliciteerd! Je bent nu onderdeel van de familie commissie. Je hebt toegang tot speciale beheer functies voor het familie weekend.",
    lottieSource: require("@/assets/lottie/familieadmin_explainer/Robot_Assistant.json"),
    icon: "star",
  },
  {
    id: "teams",
    title: "Teams & Leden",
    description: "Maak teams aan, voeg leden toe, wijs voogden aan kinderen toe, en shuffle gebruikers voor eerlijke verdeling.",
    lottieSource: require("@/assets/lottie/familieadmin_explainer/Connection.json"),
    icon: "people",
  },
  {
    id: "games",
    title: "Spellen & Opdrachten",
    description: "Creëer quizzen, speurtochten en foto-opdrachten. Beoordeel inzendingen en ken punten toe aan teams.",
    lottieSource: require("@/assets/lottie/familieadmin_explainer/Bot_Chat.json"),
    icon: "game-controller",
  },
  {
    id: "agenda",
    title: "Agenda, Familie Dag & Reveals",
    description: "Plan evenementen voor het weekend én de Familie Dag. Stel locaties in, hints, reveals en stuur notificaties naar de familie.",
    lottieSource: require("@/assets/lottie/familieadmin_explainer/Virtual_Simulation.json"),
    icon: "calendar",
  },
  {
    id: "help",
    title: "Hulp Nodig?",
    description: "Bekijk de volledige handleiding in het admin menu via \"📖 Handleiding\". Daar vind je stap-voor-stap uitleg voor alle functies.",
    lottieSource: require("@/assets/lottie/familieadmin_explainer/Robot_Thinking.json"),
    icon: "help-circle",
  },
];

/**
 * Final button text for admin onboarding
 */
export const ADMIN_ONBOARDING_BUTTON_TEXT = "Aan de slag!";

/**
 * Lottie key for admin role assignment notification
 */
export const ADMIN_ROLE_NOTIFICATION_LOTTIE = "head_with_crown_emoji";

